import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminTable } from "../../components/admin/AdminTable";
import { Badge } from "../../components/ui/Badge";
import { EmptyState } from "../../components/ui/EmptyState";
import { FullPageLoader } from "../../components/ui/FullPageLoader";
import { useDataHealth } from "../../hooks/useDataHealth";
import { formatDateTime, titleCase } from "../../lib/format";

export function AdminDataHealthPage() {
  const { data: checks, loading, error } = useDataHealth();

  if (loading) return <FullPageLoader label="Running data health checks" />;
  if (error) return <EmptyState title="Unable to run data health checks.">{error}</EmptyState>;

  return (
    <div>
      <AdminPageHeader title="Data Health" description="Detect broken relationships, stale invites and risky operational states." />
      {checks?.length ? (
        <AdminTable headers={["Severity", "Check", "Message", "Entity", "Created"]}>
          {checks.map((check) => (
            <tr key={`${check.check_key}-${check.entity_id}`}>
              <td className="px-4 py-3">
                <Badge tone={check.severity === "critical" ? "danger" : check.severity === "warning" ? "warning" : "info"}>{check.severity}</Badge>
              </td>
              <td className="px-4 py-3">{titleCase(check.check_key)}</td>
              <td className="px-4 py-3">{check.message}</td>
              <td className="px-4 py-3">{check.entity_type}</td>
              <td className="px-4 py-3">{formatDateTime(check.created_at)}</td>
            </tr>
          ))}
        </AdminTable>
      ) : (
        <EmptyState title="No data health warnings.">The current foundation checks did not find broken relationships or risky states.</EmptyState>
      )}
    </div>
  );
}
